import { get, getConfig } from '@barbanet/api-service'

import { ref } from 'vue'

import { useExceptionHandler } from '@barbanet/ui-kit/composables'

import { useUiInstructionStore } from '../stores/ui-instruction-store'
import { UserStatusCheckResponse } from '../types'

export function useUserStatusCheck() {
	const uiInstructionStore = useUiInstructionStore()

	const checking = ref(false)

	const canCheck = () => {
		const config = getConfig()

		if (config && config.credentials && config.credentials.accessToken) {
			return true
		}

		return false
	}

	const check = async () => {
		if (!canCheck()) {
			return
		}

		checking.value = true

		try {
			const response = await get<UserStatusCheckResponse>(
				'user',
				'users/status/check'
			)

			if (response && response.data) {
				if (response.data.content.status === 4) {
					uiInstructionStore.set(response.data.content.uiInstruction)
				}

				return response.data
			}

			return null
		} catch (error) {
			useExceptionHandler(error)
		} finally {
			checking.value = false
		}
	}

	return {
		checking,
		canCheck,
		check
	}
}
